import React from 'react'

const SvgFilter = ({ stroke = '#191923', ...props }): React.ReactElement => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <path
      d="M5.5 6.5h21l-8.25 9.75v8.25l-4.5 2.25V16.25z"
      fill="none"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity={0.8}
    />
  </svg>
)

export default SvgFilter
